import React from 'react';
import styled from 'styled-components';
import config from '../../../core/config';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
export const EditFieldLink = styled.a`
  color: #1e1f20;
  cursor: pointer;
  flex: 1;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-decoration: underline;
`;

class ChangePasswordForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
    }
  }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  render () {
    return (
      <Container>
        <EditFieldLink
          href={`${config.sso.url}/change-password?client_id=${config.sso.clientId}&redirect_uri=${window.location.href}`}
        >
          Change your St. James account password
        </EditFieldLink>
      </Container>
    );
  }
};

export default ChangePasswordForm;
